import type { ReactNode } from "react";
import { CanvasToolbarShell } from "./CanvasToolbarShell";

interface CanvasFloatingToolbarFrameProps {
  children: ReactNode;
  className?: string;
  onMouseDown?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onPointerDown?: (e: React.PointerEvent<HTMLDivElement>) => void;
}

/**
 * Zoom-invariant floating toolbar chrome — horizontal shell in a plain
 * wrapper. It appears and disappears without enter/exit motion on purpose:
 * the toolbar is portalled inside the canvas viewport, and in WebKit an
 * opacity/transform animation there promotes the whole viewport to a
 * composited layer, which rasterises every node at device scale and blurs
 * text at any zoom but 1 for the animation's duration (on every select and
 * deselect). Callers may still wrap it in `AnimatePresence`; with no exit
 * animation declared it unmounts immediately.
 */
export function CanvasFloatingToolbarFrame({
  children,
  onMouseDown,
  onPointerDown,
  className,
}: CanvasFloatingToolbarFrameProps) {
  return (
    <div
      className={className ?? "mx-auto w-fit"}
      onMouseDown={onMouseDown}
      onPointerDown={onPointerDown}
    >
      <CanvasToolbarShell orientation="horizontal" className="max-w-none">
        {children}
      </CanvasToolbarShell>
    </div>
  );
}
